import { render, staticRenderFns } from "./EstudianteCambiarPassword.vue?vue&type=template&id=ed055df2&"
import script from "./EstudianteCambiarPassword.vue?vue&type=script&lang=js&"
export * from "./EstudianteCambiarPassword.vue?vue&type=script&lang=js&"
import style0 from "./EstudianteCambiarPassword.vue?vue&type=style&index=0&id=ed055df2&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports